import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import UnitInput from '@/modules/workforce/Contracts/components/CreateAndEdit/Steps/ContractTypeInputs/UnitBase/UnitInput';
import { IContracts } from '@/modules/workforce/Contracts/types';
import { Typography } from '@/shared/components/atoms';
import ConfirmationModal from '@/shared/components/molecules/ConfirmationModal';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import Box from '~/images/contract/box.svg';

function UnitBase() {
  const { t } = useTranslation('common');

  const { control } = useFormContext<IContracts.IAddContractSchema>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'unitBased',
  });

  const { openModal } = useModal();

  const handleAddNewUnit = () => {
    const emptyUnit: IContracts.IContracUnitBasedSchema = {
      unitId: undefined,
      unitPrice: undefined,
      unitName: undefined,
      unitEditable: true,
    };
    append(emptyUnit);
  };

  const handleRemove = (index: number) => {
    openModal(
      <ConfirmationModal
        variant='danger'
        header={t('delete-unit-confirmation')}
        confirmText={t('delete')}
        onConfirm={() => remove(index)}
        buttonsAlignment='col'
      />,
      {
        dismissable: false,
      }
    );
  };

  return (
    <div>
      <Typography
        variant='h3'
        weight='semiBold'
        className='flex items-center gap-8 py-24 capitalize'
      >
        <Box /> {t('units')}
      </Typography>
      {fields.map((field, index) => (
        <UnitInput
          key={field.id}
          index={index}
          handleAppend={handleAddNewUnit}
          handleRemove={() => handleRemove(index)}
        />
      ))}
    </div>
  );
}

export default UnitBase;
